<template>
    <div>
        <b-btn @click="() => open()" variant="primary" class="float-right">
            {{ $t('button.GenerateGroups') }}
        </b-btn>
        <b-modal
                ref="createModal"
                :no-close-on-backdrop="true"
                size="lg"
                :title="$t('button.GenerateGroups')"
                title-tag="h3"
                v-model="modalShow"
        >
            <div class="d-block text-center">
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <formly-form :form="form" :model="model" :fields="fields" ref="create"/>
            </div>
            <div slot="modal-footer" class="w-100 text-right">
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '')"
                        variant="secondary"
                        @click="modalShow = false"
                        :disabled="disabled"
                >
                    {{$t('button.Close')}}
                </b-btn>
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '') + ' ml-3'"
                        variant="primary"
                        @click="submit"
                        :disabled="disabled"
                >
                    {{$t('button.Generate')}}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
  import {BModal} from 'bootstrap-vue/src/components/modal/modal';
  import {BButton} from 'bootstrap-vue/src/components/button/button';
  import validation from '../../utils/preDefinedValidation';
  import {mapActions} from 'vuex';
  import {ROUTER_NAMES} from "../../constants";

  export default {
    name: "EventsGenerateGroupModal",
    components: {
      BModal: BModal,
      BBtn: BButton
    },
    props: ['eventId'],
    data() {
      return {
        disabled: false,
        modalShow: false,
        error: null,
        form: {},
        model: {
          groupsCount: 0
        },
        fields: [
          {
            key: 'groupsCount',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.NumberOfGroups')
            },
            required: true,
            validators: {
              validName: validation.validNumber
            }
          },
        ]
      }
    },
    methods: {
      ...mapActions(['generateGroups']),
      open() {
        this.modalShow = !this.modalShow;
      },
      submit() {
        this.$wait.start('generate');

        this.generateGroups({eventId: this.eventId, groupsCount: this.model.groupsCount}).then(() => {
          this.$wait.end('generate');
          this.modalShow = false;
          this.$router.go();
        }, () => this.$wait.end('generate'));
      }
    }
  }
</script>

<style scoped>

</style>
